import { Link } from "@tanstack/react-router";
import Markdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

const APP_URL = process.env.APP_URL ?? "https://morty.app";

function isInternalUrl(href: string): boolean {
  if (href.startsWith("/") || href.startsWith("#")) {
    return true;
  }
  try {
    const url = new URL(href);
    const appHost = new URL(APP_URL).hostname;
    return url.hostname === appHost;
  } catch {
    return false;
  }
}

function getInternalPath(href: string): string {
  try {
    const url = new URL(href);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
}

const markdownComponents = {
  a: ({ href, children }: { href?: string; children?: React.ReactNode }) => {
    if (!href) {
      return <>{children}</>;
    }
    if (isInternalUrl(href)) {
      return <Link to={getInternalPath(href)}>{children}</Link>;
    }
    return (
      <a href={href} rel="noopener noreferrer" target="_blank">
        {children}
      </a>
    );
  },
};

interface DescriptionProps {
  description: string;
}

export default function Description({ description }: DescriptionProps) {
  return (
    <div className="mt-5 border-white/8 border-t pt-5 md:mt-7.5 md:pt-7.5">
      <h3 className="font-semibold text-16/[1.5em] text-white md:text-24/[1.2em]">
        About this location
      </h3>
      <div className="**:mt-5 **:text-14/[1.7em] **:text-pale-lavender md:**:mt-4 [&_a]:underline [&_a]:hover:no-underline">
        <Markdown
          components={markdownComponents}
          remarkPlugins={[remarkGfm, remarkBreaks]}
        >
          {description}
        </Markdown>
      </div>
    </div>
  );
}
